import { AppTierTypeGq } from './AppTierTypeGq';

export interface AppTierGq {
  id: number;
  name: string;
  includedUsers: number;
  includedTeams: number;
  monthlyCapSearchVolumeKw: number;
  monthlyCapTranslateKw: number;
  monthlyCapRankKw: number;
  monthlyCapChatGptDrafts: number;
  tierType: AppTierTypeGq;
}

export const AppTierGqProps = `
  id
  name
  includedUsers
  includedTeams
  monthlyCapSearchVolumeKw
  monthlyCapTranslateKw
  monthlyCapRankKw
  monthlyCapChatGptDrafts
  tierType
`;
